module.exports = __webpack_public_path__ + "static/img/fyfwsm.0bccc33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fyfwsm.png
// module id = vFsg
// module chunks = 1